import React from 'react';
import '../styles/main.scss';
import { AttachmentsModel } from '../models/Attachments';

interface AttachmentsProps {
  data?: AttachmentsModel;
  onSubmit: (data: AttachmentsModel) => void;
  onBack: () => void;
}

interface AttachmentsState extends AttachmentsModel {
  showTermsModal: boolean;
}

class Attachments extends React.Component<AttachmentsProps, AttachmentsState> {
  constructor(props: AttachmentsProps) {
    super(props);
    this.state = {
      ...(props.data || {
        photo: null,
        signPhoto: null,
        adhaarCard: null,
        panCard: null,
        nomineeAdhaarCard: null,
        isTermsAccepted: false
      }),
      showTermsModal: false
    };
  }

  handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target;
    const file = e.target.files?.[0] || null;
    this.setState({
      [name]: file
    } as unknown as Pick<AttachmentsState, keyof AttachmentsState>);
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked
    } as unknown as Pick<AttachmentsState, keyof AttachmentsState>);
  };

  toggleModal = () => {
    this.setState(prevState => ({ showTermsModal: !prevState.showTermsModal }));
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // validation: if minor, guardian name required
    if (!this.state.photo) {
      alert('કૃપા કરીને ફોટો અપલોડ કરો (Photo is required).');
      return;
    }
    if (!this.state.isTermsAccepted) {
      alert('કૃપા કરીને નિયમો અને શરતો સ્વીકારો.');
      return;
    }
    const { showTermsModal, ...data } = this.state;
    this.props.onSubmit(data);
  };

  renderFileInput = (label: string, name: keyof AttachmentsModel, required: boolean = false) => {
    const value = this.state[name] as File | null;
    return (
      <div>
        <label className="text-muted">{label}</label>
        <input
          type="file"
          name={name}
          accept="image/*,.pdf"
          onChange={this.handleFileChange}
          required={required}
        />
        {value && value instanceof File && <p className="file-uploaded-text">{value.name}</p>}
      </div>
    );
  };

  render() {
    const { showTermsModal, isTermsAccepted } = this.state;

    return (
      <div className="registration-container">
        <h2 className="form-heading">સંલગ્નક</h2>
        <form className="form-grid" onSubmit={this.handleSubmit}>
          {this.renderFileInput('ફોટો (Photo)', 'photo', true)}
          {this.renderFileInput('સહી સાથે ફોટો (Sign Photo)', 'signPhoto')}
          {this.renderFileInput('આધાર કાર્ડ (Adhar Card)', 'adhaarCard')}
          {this.renderFileInput('PAN કાર્ડ (PAN Card)', 'panCard')}
          {this.renderFileInput('વારસદારનું આધાર કાર્ડ (Nominee Adhar Card)', 'nomineeAdhaarCard')}

          <div className="checkbox-group">
            <input
              type="checkbox"
              name="isTermsAccepted"
              checked={isTermsAccepted}
              onChange={this.handleChange}
              id="terms"
            />
            <label htmlFor="terms" className="text-muted">
              હું <button type="button" onClick={this.toggleModal} className="link-button">નિયમો અને શરતો</button> સાથે સંમત છું.
            </label>
          </div>

          <div className="button-group">
            <button type="button" onClick={this.props.onBack} className="form-btn secondary">
              પાછા
            </button>
            <button type="submit" className="form-btn">
              આગળ વધો
            </button>
          </div>
        </form>

        {showTermsModal && (
          <div className="terms-modal">
            <div className="terms-content">
              <h3>નિયમો અને શરતો</h3>
              <div>
                <p className="text-muted">1. આ વીમા પોલિસી માત્ર ભારતીય નાગરિકો માટે છે.</p>
                <p className="text-muted">2. આપેલી તમામ માહિતી સાચી અને સચોટ હોવી જોઈએ.</p>
                <p className="text-muted">3. કોઈપણ ખોટી માહિતી આપવા બદલ પોલિસી રદ થઈ શકે છે.</p>
                <p className="text-muted">4. મેડિકલ હિસ્ટ્રી છુપાવવી એ વીમા નિયમોનું ઉલ્લંઘન છે.</p>
                <p className="text-muted">5. ક્લેમ સેટલમેન્ટ કંપનીના નિયમોને આધીન રહેશે.</p>
              </div>
              <div className="terms-footer">
                <button type="button" onClick={this.toggleModal} className="form-btn">બંધ કરો</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Attachments;
